/*
 * The frame of Telify's shop pages (the Prints mockup's .flow): the bag, the
 * checkout and the order page sit in the site's header and footer, in theme
 * tokens. In the telify layer.
 */
@layer telify {
  .flow {
    padding-block: 60px 140px;
  }

  /* The bag page: one column, the drawer's width grown for a page. */
  .narrow {
    max-width: 680px;
  }

  .emptyCheckout {
    display: grid;
    justify-items: center;
    gap: 20px;
    text-align: center;
  }

  .emptyCheckout p {
    font-family: var(--font-display);
    font-size: 22px;
    color: var(--text-secondary);
  }

  @media (max-width: 860px) {
    .flow {
      padding-block: 34px 120px;
    }
  }
}
